import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: `0 ${theme.spacing(1)}`,
        border: `1px solid transparent`,
    },
    containerHover: {
        "&:hover": {
            cursor: "pointer",
            border: `1px dashed ${theme.palette.border.main}`,
            "& > hr": {
                opacity: 0,
            },
        },
    },
    containerSelected: {
        opacity: 1,
    },
    containerNotSelected: {
        opacity: 0.5,
    },
    title: {
        fontSize: `12px !important`,
        color: theme.palette.text.secondary,
    },
    progressBar: {
        width: "100%",
        display: "flex",
        alignItems: "center",
    },
    machineTitleContainer: {
        display: "flex",
        justifyContent: "space-between",
    },
    percentagesContainter: {
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
    },
    downtime: {
        height: theme.spacing(2),
        backgroundColor: theme.palette.error.main,
        borderTopRightRadius: 50,
        borderBottomRightRadius: 50,
    },
    downtimeTitle: {
        fontSize: `12px !important`,
        color: theme.palette.error.main,
    },
    uptime: {
        height: theme.spacing(2),
        backgroundColor: theme.palette.success.main,
        borderTopLeftRadius: 50,
        borderBottomLeftRadius: 50,
        textAlign: "right",
        marginRight: theme.spacing(0.5),
    },
    uptimeTitle: {
        fontSize: `12px !important`,
        color: theme.palette.success.main,
    },
    divider: {
        marginTop: `${theme.spacing(2)} !important`,
    },
}));
